import { VehicleCategoryType } from "@/types"
import { useFetch } from "@develos/next-library"
import { useMemo } from "react"

export const useVehicleCategories = () => {
    const { get } = useFetch();
    const { data: responseData, isLoading } = get<VehicleCategoryType[]>("Category/GetCost323Categories");

    const categories: VehicleCategoryType[] | null = useMemo(() => {
        if(!responseData || isLoading) {
            return [];
        }
        return responseData;
    }, [responseData]) 

    const getCategoryDescription = (categoryId: number) => {
        const category = categories.find((obj: VehicleCategoryType) => {
            return obj.id === categoryId;
          });
          if (category !== undefined) {
              return category.name;
          }
          return categoryId.toString();
    }

    return {
        isLoading,
        categories,
        getCategoryDescription
    }
}